import Vue from 'vue'
import VueResource from 'vue-resource'

Vue.use(VueResource)

export default {
    fillBrandingVariant(context, payload) {
        // let host = document.location.hostname
        if (String(payload).includes('artics') || String(payload).includes('localhost')) {
            context.commit('setBrandingOption', 'artics');
            //document.title = context.state.designVariant['artics'].titles.main
        }
        if (String(payload).includes('daskipper')) {
            context.commit('setBrandingOption', 'daskipper');
            //document.title = context.state.designVariant['daskipper'].titles.main
        }
    },
    toggleUserTheme(context) {
        context.commit('toggleUserTheme')
        Vue.http.post(
            context.getters.authHandler + '/meta', context.state.userData.meta, { headers: context.getters.secureHeaders }
        ).then((r) => {
            let response = r.body
            if (response.result) {
                context.commit('updateUserMeta', response.data)
            } else {
                console.log('response')
            }
        })
    }
}